import {  useState } from "react";
import { getCookie, setCookie } from "../helpers/cookie";

export function useCoachingBannerVisibility() {
    const [isShowCoachBanner, setIsShowCoachBanner] = useState(false)

    const updateLessonCounter = () => {
        let playedLessonCounter = parseInt(localStorage.getItem('playedLessonCounter') || "0");
        let whichBanner = parseInt(localStorage.getItem('whichBanner') || "0");

        console.log(playedLessonCounter,"playedLessonCounter");
        playedLessonCounter += 1;
        if(getCookie('isShowCoachBanner')){
            // Return after test
            // playedLessonCounter =0;
        } 
        localStorage.setItem('playedLessonCounter', playedLessonCounter.toString());
        // Return after test
        // if (playedLessonCounter % 10 === 0 && !getCookie('isShowCoachBanner')) {
        //     setIsShowCoachBanner(true); 
        //     setCookie('isShowCoachBanner', 'true', 1); 
        //     setTimeout(() => {
        //         setIsShowCoachBanner(false);
        //     }, 13000);
        // }
          if (playedLessonCounter % 10 === 0) {
            whichBanner+=1
            setIsShowCoachBanner(true); 
            localStorage.setItem('whichBanner', whichBanner.toString());
            // setCookie('isShowCoachBanner', 'true', 1); 
            setTimeout(() => {
                setIsShowCoachBanner(false);
            }, 13000);
        }
    };

    return { isShowCoachBanner, updateLessonCounter };
}
